import { useDispatch } from "react-redux";
import { captureOpenReplayEvent } from "actions/tracker";
import { useCallback } from "react";
import { posthogCaptureEvent } from "Tracking";

const useApplicationTracker = () => {
  const dispatch = useDispatch();

  const captureSessionEvent = useCallback((eventType, eventData) => {
    dispatch(captureOpenReplayEvent(eventType, eventData));
  }, []);

  const captureUserEvent = useCallback(
    (eventType, eventData) => {
      captureSessionEvent(eventType, eventData);
      posthogCaptureEvent(eventType, eventData);
    },
    [captureSessionEvent, posthogCaptureEvent]
  );

  return {
    captureSessionEvent,
    captureUserEvent,
  };
};

export default useApplicationTracker;
